"use client"

import {
    X, Palette, Layers, Type, Upload, Shirt, PlusIcon, ShoppingCart, SunIcon, MoonIcon, ExpandIcon, ShrinkIcon,
    Contact2Icon, BoxesIcon, Plus, TrashIcon, RefreshCcw, BrushCleaningIcon, EditIcon, List, EyeIcon
} from "lucide-react"
import { Button } from "../../components/ui/button"
import { useEffect, useRef, useState } from "react"
import { Footer } from "./footer";
import { KitPicker } from "./KitPicker";
import { ArrowBack } from "@mui/icons-material";
import { InputModal } from "./inputModal";
import { BudgetModal } from "./iframe-budget";
import $ from "jquery";
import { Separator } from "../../components/ui/separator"

interface Category {
    id: string
    name: string
    color: string
    description: string
}

interface CustomizationModalProps {
    isOpen: boolean
    onClose: () => void
    category: Category | null
}

const categories2 = [{ id: 'todos', label: 'Todos os projetos', index: 0 }]

export function CustomizationModal({
    isOpen,
    onClose,
    category,
}: CustomizationModalProps) {
    const modalRef = useRef<HTMLDivElement>(null);
    const [categories, setCategories] = useState(categories2);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isOpenModalDesc, setIsOpenModalDesc] = useState(false);
    const [textDesc, setTextDesc] = useState("");
    const openModalDesc = () => setIsOpenModalDesc(true);
    const closeModalDesc = () => setIsOpenModalDesc(false);
    const saveModalDesc = () => {
        closeModalDesc();
    };
    const [isOpenModalList, setIsOpenModalList] = useState(false);
    const [textList, setTextList] = useState("");
    const openModalList = () => setIsOpenModalList(true);
    const closeModalList = () => setIsOpenModalList(false);
    const saveModalList = () => {
        closeModalList();
    };

    useEffect(() => {
        const handleEscape = (e: KeyboardEvent) => { if (e.key === "Escape") onClose() }

        if (isOpen) {
            document.body.style.overflow = "hidden"
            window.addEventListener("keydown", handleEscape)
        }

        return () => {
            document.body.style.overflow = ""
            window.removeEventListener("keydown", handleEscape)
        }
    }, [isOpen, onClose])

    if (!isOpen || !category) return null

    const tools = [
        {
            icon: Shirt,
            label: "Estilo",
            description: "Altere o modelo e corte",
            id: "layout-first",
            title: "Layouts",
            type: "layouts",
            display: "flex"
        },
        {
            icon: Palette,
            label: "Cores",
            description: "Escolha e personalize as cores",
            id: "iframe-colors",
            title: "Cores",
            type: "color",
            display: "flex"
        },
        {
            icon: Type,
            label: "Texto",
            description: "Insira nomes, números e frases",
            id: "iframe-texts",
            title: "Textos",
            type: "text",
            display: "flex"
        },
        {
            icon: Upload,
            label: "Logo",
            description: "Faça upload do seu logo",
            id: "iframe-logos",
            title: "Logos",
            type: "logos",
            display: "flex"
        },
        {
            icon: Layers,
            label: "Padrões",
            description: "Adicione padrões e texturas",
            id: "iframe-layers",
            title: "Cliparts",
            type: "cliparts",
            display: "flex"
        },
        {
            icon: RefreshCcw,
            label: "Resetar Layout",
            description: "Layout volta ao estado inicial",
            id: "reset-iframe2",
            title: "Resetar Layout",
            type: "none",
            display: "flex"
        }
    ];

    (window as any)['setCategoriesProjectsIframe'] = function (array: any) { setCategories(array) };

    function openModalBudget() {
        setIsModalOpen(true);
        (window as { [key: string]: any })["setupCamera"]();

        setTimeout(() => {

            if ((window as any).dataShared.visibility == "private") {
                if ((window as any).dataShared.userInfo.name)
                    (window as any).setClientName((window as any).dataShared.userInfo.name)

                if ((window as any).dataShared.userInfo.phone)
                    (window as any).setClientPhone((window as any).dataShared.userInfo.phone)
            }

            // Agora, pegue o canvas como imagem:
            const dataURL = (window as { [key: string]: any }).renderer.domElement.toDataURL('image/png');

            (window as { [key: string]: any }).addKit(
                $("#kit-iframe-title").text(),
                dataURL,
                (window as { [key: string]: any }).fabricCanvas.toDataURL("image/webp"),
                (window as { [key: string]: any }).fabricCanvas.toSVG(),
                [
                    { id: "1", name: "Camisa", selected: true, quantity: 5, price: 1 },
                    { id: "2", name: "Calção", selected: true, quantity: 6, price: 2 },
                    { id: "3", name: "Meias", selected: true, quantity: 7, price: 3 },
                ]
            )

            const sellers = (window as { [key: string]: any }).sellers;

            for (var i = 0; i < sellers.length; i++) {

                const elem = "<div data-phone='" + sellers[i].phone + "'>" +
                    "<div class='seller' data-phone='" + sellers[i].phone + "' style='background-image: url(https://nfghuenhuaecfyccyaib.supabase.co/storage/v1/object/public/images/" + sellers[i].thumb + ")'></div>" +
                    "<span>" + sellers[i].name + "</span>" +
                    "<button class='send-message-iframe'>ENVIAR ORÇAMENTO</button>" +
                    "</div>";

                $("#list-sellers").append(elem);
            }
        }, 100);
    }

    const setRotationText = function (value: any) { (window as any)["rotate-text-iframe"](value) }

    const setRotationImage = function (value: any) { (window as any)["rotate-logo-iframe"](value) }

    const setScaleImage = function (value: any) { (window as any)["scale-logo-iframe"](value) }

    $("body").on("click", "#iframe-obs", function (event) { openModalDesc(); });

    $("body").on("click", "#iframe-list", function (event) { openModalList(); });

    return (
        <div
            className="fixed inset-0 z-50 flex items-center justify-center p-0"
            onClick={(e) => {
                if (e.target === e.currentTarget) onClose()
            }} >
            <Button id="full-close" className="fixed top-5 right-5 !z-[100000000000000000] hidden">
                <X></X>
            </Button>
            {/* Backdrop */}
            <div className="absolute inset-0 bg-background/80 backdrop-blur-md" />
            {/* Modal */}
            <div
                ref={modalRef}
                className="relative w-full h-full bg-card border border-none overflow-hidden shadow-2xl">
                {/* Header */}
                <div className="flex items-center justify-between p-6 border-b border-border content-iframe">
                    <div className="hidden md:flex items-center gap-3">
                        <div
                            className="w-10 h-10 rounded-xl flex items-center justify-center"
                            style={{
                                background: `linear-gradient(135deg, hsl(${category.color} 50% 40%), hsl(${category.color} 50% 50%))`,
                            }}>
                            <Shirt size={20} className="text-foreground" />
                        </div>
                        <div>
                            <h2 className="text-2xl font-bold hidden md:flex" >
                                Personalizar {category.name}
                            </h2>
                            <p className="text-sm text-muted-foreground">
                                {category.description}
                            </p>
                        </div>
                    </div>
                    <div className="flex gap-3">
                        <Button
                            id="btn-budget" onClick={() => openModalBudget()}
                            className="bg-primary text-primary-foreground bg-[orange]"
                            style={{
                                boxShadow: `0 8px 32px hsl(${category.color} 50% 50% / 0.3)`,
                            }}
                        >
                            <ShoppingCart></ShoppingCart>
                            {!(window as any).isMobile ? (<span>ORÇAMENTO</span>) : null}
                        </Button>
                        <Button id="btn-footer-show" className="bg-secondary text-primary hover:bg-primary hover:text-secondary">
                            <Contact2Icon></Contact2Icon>
                        </Button>
                        <Button className="bg-secondary text-primary hover:bg-primary hover:text-secondary" id="ar-iframe">
                            <BoxesIcon></BoxesIcon>
                        </Button>
                        <Button className="bg-secondary text-primary hover:bg-primary hover:text-secondary hidden" id="ar-iframe-ios">
                            <BoxesIcon></BoxesIcon>
                        </Button>
                        <Button id="theme-iframe" className="bg-secondary text-primary hover:bg-primary hover:text-secondary">
                            <SunIcon id="theme-iframe-sun"></SunIcon>
                            <MoonIcon id="theme-iframe-moon" className="hidden"></MoonIcon>
                        </Button>
                        <Button id="full-iframe" className="bg-secondary text-primary hover:bg-primary hover:text-secondary">
                            <ExpandIcon id="full-expand"></ExpandIcon>
                            <ShrinkIcon id="full-shrink" className="hidden"></ShrinkIcon>
                        </Button>
                    </div>
                </div>
                {/* Content */}
                <div className="flex flex-col lg:flex-row h-[calc(100vh-90px)] overflow-hidden">
                    {/* Preview */}
                    <div className="flex-1 relative flex items-center justify-center bg-background !z-[10000000]" id="container-iframe66">

                        <div className="w-full h-full flex justify-center items-center absolute">
                            <div id="interactionHint">
                                <div className="icon">🖱️</div>
                                <span>Arraste para girar</span>
                            </div>
                        </div>
                    </div>
                    {/* Sidebar */}
                    <div id="side-iframe" className="content-iframe w-full lg:w-80 border-t lg:border-l border-border p-3 md:p-6 overflow-y-auto h-[50%] md:h-full">
                        <div className="flex">
                            <h3 className="text-lg font-bold mb-4" id="title-menu-iframe">
                                Ferramentas de Customização
                            </h3>
                            <Button className="right-7 absolute hidden" id="back-iframe-main">
                                <ArrowBack></ArrowBack>
                                Voltar
                            </Button>
                        </div>
                        {/**Options Layouts */}
                        <div id="iframe-body-layouts" className="hidden iframe-body-options rounded-lg bg-secondary">
                            <div id="iframe-body-layouts-list" className={`w-full grid gap-0 ${(window as any).isMobile ? "grid-cols-2" : "grid-cols-2"}`}></div>
                        </div>
                        {/**Options Colors */}
                        <div id="iframe-body-color" className="theme-change-color iframe-body-options rounded-lg hidden">
                            <div id="new-list-iframe" className="overflow-y-auto max-h-[29vh] md:max-h-[90vh] w-full">
                                <Separator className="bg-border/50"></Separator>
                                <div id="cores-iframe-camisa" className="cores-iframe flex justify-left items-center">
                                    <span className="w-[60px]">Camisa:</span>
                                    <div id="cores-iframe-camisa-list" className="cores-iframe-list"></div>
                                </div>
                                <Separator className="bg-border/50"></Separator>
                                <div id="cores-iframe-gola" className="cores-iframe flex justify-left items-center">
                                    <span className="w-[60px]">Gola:</span>
                                    <div id="cores-iframe-gola-list" className="cores-iframe-list"></div>
                                </div>
                                <Separator className="bg-border/50"></Separator>
                                <div id="cores-iframe-manga" className="cores-iframe flex justify-left items-center">
                                    <span className="w-[60px]">Manga:</span>
                                    <div id="cores-iframe-manga-list" className="cores-iframe-list"></div>
                                </div>
                                <Separator className="bg-border/50"></Separator>
                                <div id="cores-iframe-short" className="cores-iframe flex justify-left items-center">
                                    <span className="w-[60px]">Calção:</span>
                                    <div id="cores-iframe-short-list" className="cores-iframe-list"></div>
                                </div>
                                <Separator className="bg-border/50"></Separator>
                                <div id="cores-iframe-meia" className="cores-iframe flex justify-left items-center">
                                    <span className="w-[60px]">Meião:</span>
                                    <div id="cores-iframe-meia-list" className="cores-iframe-list"></div>
                                </div>
                                <Separator className="bg-border/50"></Separator>
                                <div id="cores-iframe-outros" className="cores-iframe flex justify-left items-center">
                                    <span>Outros</span>
                                    <div id="cores-iframe-outros-list" className="cores-iframe-list  flex justify-center"></div>
                                </div>
                                <Separator className="bg-border/50"></Separator>
                                <div id="cores-iframe-grad" className="cores-iframe">
                                    <span className="w-[100px]">Gradiente</span>
                                    <div id="cores-iframe-grad-list" className="cores-iframe-list flex justify-left items-center"></div>
                                </div>
                                <div id="cores-iframe-table" className="h-full">
                                    <div id="cores-iframe-header" className="relative">
                                        <div className="flex">
                                            <span id="title-part-cor">Cor Atual:</span>
                                            <div id="current-color" className="w-[30px] !h-[30px] ml-1"><div></div></div>
                                        </div>
                                        <div className="flex">
                                            <span>Usadas:</span>
                                            <div id="current-used-colors" className="ml-1"><div></div></div>
                                        </div>
                                        <span>Escolha uma nova cor:</span>
                                    </div>
                                    <div id="cores-iframe-table-list" className="overflow-y-auto grid grid-cols-6 gap-0 relative overflow-hidden"></div>
                                </div>
                                <div id="cores-iframe-table-grad">
                                    <button className="bg-[orange] relative p-1 !w-full" id="back-color-table-grad">
                                        <ArrowBack></ArrowBack>
                                        Voltar
                                    </button>
                                    <div id="iframe-color-stops"></div>
                                    <div className="flex w-full flex mb-[20px] mt-[20px] justify-center items-center">
                                        <input type="checkbox" id="state-grad-all"></input>
                                        <span>Aplicar a todos:</span>
                                    </div>
                                    <span className="t-[20px]">Escolha a cor:</span>
                                    <div id="cores-iframe-table-list-grad"></div>
                                </div>
                            </div>
                        </div>
                        {/**Options Texts */}
                        <div id="iframe-body-text" className="p-4 hidden flex-col gap-4 iframe-body-options h-[90%]">
                            {/* FIRST */}
                            <div id="iframe-text-first" className="flex flex-col gap-3">
                                <div className="flex items-center gap-2 w-full justify-center mb-3">
                                    <span
                                        id="iframe-text-add"
                                        className="flex items-center gap-2 bg-secondary text-primary px-3 py-1 rounded cursor-pointer"
                                    >
                                        <Plus /> Adicionar
                                    </span>
                                </div>
                                <div
                                    id="iframe-text-items"
                                    className="menu-horizontal flex gap-2 overflow-x-auto text-background grid grid-cols-2 mt-7"
                                ></div>
                            </div>
                            {/* SECOND */}
                            <div
                                id="iframe-text-second"
                                className="flex flex-col gap-4 p-4 rounded-lg shadow">
                                <span className="text-center text-sm text-gray-600 drag-obj">
                                    Você pode arrastar esse texto segurando com um dedo na roupa e arrastando para o local desejado.
                                </span>
                                {/* FORM */}
                                <div className="grid grid-cols-2 gap-4 mt-5">
                                    <div className="flex flex-col">
                                        <label className="text-sm">Texto</label>
                                        <input
                                            type="text"
                                            id="content-text-iframe"
                                            className="border rounded px-2 py-1 text-primary bg-secondary" />
                                    </div>
                                    <div className="flex flex-col">
                                        <label className="text-sm">Cor do Texto</label>
                                        <input
                                            type="color"
                                            id="color-text-iframe"
                                            className="border rounded h-9 " />
                                    </div>
                                    <div className="flex flex-col">
                                        <label className="text-sm">Borda</label>
                                        <input
                                            type="number"
                                            id="border-text-iframe"
                                            defaultValue={0}
                                            className="border rounded px-2 py-1 text-primary bg-secondary" />
                                    </div>
                                    <div className="flex flex-col">
                                        <label className="text-sm">Cor da Borda</label>
                                        <input
                                            type="color"
                                            id="color-border-text-iframe"
                                            className="border rounded h-9" />
                                    </div>
                                    <div className="flex flex-col">
                                        <label className="text-sm">Tamanho</label>
                                        <input
                                            type="number"
                                            id="size-text-iframe"
                                            defaultValue={20}
                                            className="border rounded px-2 py-1 text-primary bg-secondary" />
                                    </div>
                                    <div className="flex flex-col">
                                        <label className="text-sm">Fonte</label>
                                        <button
                                            id="iframe-font-open"
                                            className="border rounded px-2 py-1 bg-secondary text-primary w-full">
                                            Selecionar
                                        </button>
                                    </div>
                                </div>
                                <div className="flex flex-col mt-4">
                                    <label className="text-sm">Rotação</label>
                                    <input
                                        type="range"
                                        id="rotate-text-iframe"
                                        min={0}
                                        max={360}
                                        className="w-full mt-2"
                                        onChange={(e) => {
                                            const value = Number(e.target.value)
                                            setRotationText(value)
                                        }}
                                    />
                                </div>
                                <div className="flex flex-col mt-4">
                                    <Button id="delete-text-iframe" className="bg-destructive delete-iframe-text text-white">
                                        Deletar
                                        <TrashIcon></TrashIcon>
                                    </Button>
                                </div>
                            </div>
                            {/* THIRD*/}
                            <div id="iframe-text-third" className="flex flex-col gap-3 hidden h-[100%]">
                                <div
                                    id="card-fonts-iframe"
                                    className="grid grid-cols-1 gap-2 h-[100%] overflow-y-auto text-[30px]"
                                ></div>
                            </div>
                        </div>
                        {/**Options Logos */}
                        <div id="iframe-body-logos" className="iframe-body-options hidden mt-3 overflow-x-hidden w-full h-[90%]">
                            <div id="iframe-logos-first" className="w-full">
                                <div className="iframe-logos-options flex justify-center w-full">
                                    <span id="iframe-logo-add" className="relative flex justify-center items-center bg-secondary p-2 rounded-lg"><Plus></Plus> Adicionar <input className="opacity-0 top-0 absolute left-0" id="iframe-logo-input" type="file" accept="image/*"></input></span>
                                </div>
                                <div id="iframe-logos-items" className="menu-horizontal w-full grid grid-cols-3 mt-5 gap-2"></div>
                            </div>
                            <div id="iframe-logos-second" className="flex-col w-full">
                                <span className="text-center mb-2 drag-obj">Você pode arrastar essa imagem segurando com um dedo na roupa e arrastando para o local desejado.</span>
                                <div id="iframe-logo-thumb"></div>
                                <div className="m-2">
                                    <label>Escala</label>
                                    <input type="range" className="scale-logo-iframe" min={0} max={100}
                                        onChange={(e) => {
                                            const value = Number(e.target.value)
                                            setScaleImage(value)
                                        }}
                                    ></input>
                                </div>
                                <div className="m-2">
                                    <label>Rotação</label>
                                    <input type="range" className="rotate-logo-iframe" min={0} max={360}
                                        onChange={(e) => {
                                            const value = Number(e.target.value)
                                            setRotationImage(value)
                                        }}
                                    ></input>
                                </div>
                                <Button className="bg-[#6161f7] text-white m-2">
                                    <EditIcon></EditIcon>
                                    Substituir Logo
                                    <input type="file" accept="image/*" className="w-full left-0 replace-iframe-logo absolute left-0"></input>
                                </Button>
                                <Button id="delete-iframe-logo" className="bg-destructive text-white m-2 delete-iframe-logo">
                                    <TrashIcon></TrashIcon>
                                    Deletar
                                </Button>
                            </div>
                        </div>
                        {/**Options Cliparts */}
                        <div id="iframe-body-cliparts" className="py-4 iframe-body-options hidden input-options hidden input-options-patterns max-h-[90%]">
                            <div className='w-full' id="patterns-list">
                                <div className='flex md:flex-wrap justify-start md:justify-center overflow-x-auto md:overflow-x-hidden w-full' id="iframe-categories-cliparts"></div>
                                <div className='flex flex-wrap justify-center overflow-y-auto p-5 max-h-[50vh] md:max-h-[70vh] mt-5' id="iframe-cliparts"></div>
                            </div>
                            <div id="patterns-edit"></div>
                        </div>

                        <div className="space-y-3" id="menu-iframe">
                            {tools.map((tool, index) => {
                                const Icon = tool.icon
                                return (
                                    <button
                                        id={tool.id}
                                        data-title={tool.title} data-type={tool.type} data-display={tool.display}
                                        key={index}
                                        className="iframe-bottom-header-option w-full flex items-center gap-4 p-4 bg-secondary/50 hover:bg-secondary rounded-xl"
                                    >
                                        <div
                                            className="w-12 h-12 rounded-xl flex items-center justify-center"
                                            style={{
                                                background: `linear-gradient(135deg, hsl(${category.color} 50% 40% / 0.2), hsl(${category.color} 50% 50% / 0.1))`,
                                            }}>
                                            <Icon
                                                size={24}
                                                style={{ color: `hsl(${category.color} 50% 60%)` }} />
                                        </div>
                                        <div className="text-left">
                                            <div className="font-semibold">{tool.label}</div>
                                            <div className="text-sm text-muted-foreground">
                                                {tool.description}
                                            </div>
                                        </div>
                                    </button>
                                )
                            })}
                        </div>
                    </div>
                </div>
            </div>

            <Footer></Footer>

            <div className="hidden">
                <KitPicker></KitPicker>
                <InputModal></InputModal>
            </div>

            <div
                id="iframe-reset-view"
                title="RESETAR VIEW"
                data-id=""
                className="fixed top-[30%] md:top-[50%] left-[0px] z-[10000000000] bg-center bg-no-repeat cursor-pointer drop-shadow-lg text-primary bg-secondary w-[32px] !h-[32px] justify-center items-center !flex !m-0 rounded-tr-lg rounded-br-lg">
                <EyeIcon className="w-5 h-5"></EyeIcon>
            </div>

            <div className="z-[10000000000000000000000000] relative">
                <BudgetModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} />
            </div>

            {isOpenModalDesc && (
                <div className="w-full h-full fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-[10000000000000000000]">
                    <div className="w-[90%] h-[50%] bg-secondary p-6 rounded shadow-md w-80">
                        <h2 className="text-lg font-semibold mb-4">Observações do Pedido:</h2>
                        <textarea
                            value={textDesc}
                            onChange={(e) => setTextDesc(e.target.value)}
                            placeholder="Escreva aqui..."
                            className="border border-gray-300 p-2 w-full h-[75%] rounded resize-none bg-background text-primary"
                        />
                        <div className="flex justify-end mt-4 gap-2">
                            <button
                                onClick={saveModalDesc}
                                className="px-4 py-2 bg-green-500 text-white rounded">
                                Salvar
                            </button>
                            <button
                                onClick={closeModalDesc}
                                className="px-4 py-2 bg-red-500 text-white rounded">
                                Fechar
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {isOpenModalList && (
                <div className="w-full h-full fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-[10000000000000000000]">
                    <div className="w-[90%] h-[50%] bg-secondary p-6 rounded shadow-md w-80">
                        <h2 className="text-lg font-semibold mb-4">Lista de Pedidos: (nome, número, tamanho)</h2>
                        <textarea
                            value={textList}
                            onChange={(e) => setTextList(e.target.value)}
                            placeholder="Escreva aqui..."
                            className="border border-gray-300 p-2 w-full h-[62%] rounded resize-none bg-background text-primary"
                        />
                        <div className="flex justify-end mt-4 gap-2">
                            <button
                                onClick={saveModalList}
                                className="px-4 py-2 bg-green-500 text-white rounded">
                                Salvar
                            </button>
                            <button
                                onClick={closeModalList}
                                className="px-4 py-2 bg-red-500 text-white rounded">
                                Fechar
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    )
}